 /* jshint esversion: 6 */
import { createStore } from "vuex";
// import VuexPersistence from 'vuex-persist'
import getters from "./getters";
import state from "./state";
import mutations from "./mutations";
import actions from "./actions";
import app from "./modules/app";
import permission from "./modules/permission";
import user from "./modules/user";

// const vuexLocal = new VuexPersistence({
//     storage: window.localStorage,
// })

const store = createStore({
  modules: {
    app,
    permission,
    user,
  },
  state,
  getters,
  mutations,
  actions,
  // plugins: [vuexLocal.plugin]
});

export default store;
